import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

export const supportCourseAxiosInstance = buildAxiosInstance(import.meta.env.VITE_WORKSHOP_SERVICE_URL);
export const supportCourseAxios = buildMakeUseAxios(import.meta.env.VITE_WORKSHOP_SERVICE_URL);
